export enum BetTypeBitMask {
  FreebetsOn = 0b00000001,
  AutplayOn = 0b00000010,
}

export const updateBetTypeBitMask = (bit: BetTypeBitMask): void => {
  betTypeBitMask |= bit;
};

export let betTypeBitMask = 0;
